import axios from 'axios';
export const axiosPostData = (url, formData) => axios.post(url, formData);
export const axiosGetData = async (url) => {
    const response = await axios.get(url);
    return response?.data;
};
export const axiosGetDataWithHeaders = async (url, headers, signal) => {
    const response = await axios.get(url, { headers, signal });
    return response?.data;
};
export const axiosPutData = async (url, data, headers) => {
    const response = await axios.put(url, data, { headers });
    return response?.data;
};
export const axiosPostJson = async (url, data, headers) => {
    const response = await axios.post(url, data, {
        headers: {
            'Content-Type': 'application/json',
            ...headers,
        },
    });
    return response?.data;
};
